async function showPopup(type, data) {
  if (type === "confirm") {
    return Swal.fire({
      title: data.title,
      text: data.text,
      icon: data.icon,
      showConfirmButton: data.showConfirmButton ?? true,
      confirmButtonText: data.confirmButtonText,
      confirmButtonColor: data?.confirmButtonColor ?? "#2866D3",
      showCancelButton: data.showCancelButton,
      cancelButtonText: data.cancelButtonText,
      cancelButtonColor: data?.cancelButtonColor ?? "#C62A32",
      customClass: {
        popup: "custom-popup-confirm",
      },
    });
  }

  if (type === "success") {
    return Swal.fire({
      title: data.title,
      text: data.text,
      icon: data.icon,
      draggable: data.draggable ?? true,
      confirmButtonText: data.confirmButtonText,
      confirmButtonColor: data?.confirmButtonColor ?? "#2866D3",
      customClass: {
        popup: "custom-popup-confirm",
      },
    });
  }

  if (type === "error") {
    return Swal.fire({
      title: data.title,
      text: data.text,
      icon: data.icon,
      confirmButtonText: data.confirmButtonText,
      confirmButtonColor: data?.confirmButtonColor ?? "#2866D3",
      customClass: {
        popup: "custom-popup-confirm",
      },
    });
  }
}
